export enum MicrosoftDspMember {
  Drop8 = "drop8",
  None = "None",
}
